export function initNavigation() {
    const body = jQuery(document.body);
    const searchIcon = jQuery('.search-icon');
    jQuery('.nav-menu-toggle, .menu-btn').on('click', () => {
        body.toggleClass('nav-menu-open');
    })

    searchIcon.click((e) => {
        e.stopPropagation();
        searchIcon.addClass('search-open');
    });

    jQuery(window).click(() => {
        searchIcon.removeClass('search-open');
    });

    function toggleStickyHeader() {
        if (window.scrollY > 40) {
            body.addClass('sticky-header-active');
        } else {
            body.removeClass('sticky-header-active');
        }
    }
    toggleStickyHeader();
    jQuery(window).on( 'scroll', () => {
        toggleStickyHeader();
    });
}